declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

// TEMPORARY: the runtime `window._env_` mechanism (generated env-config.js) is
// not ready. While it is disabled, configuration is sourced exclusively from
// build-time env files baked by CRA into `process.env` (`.env.production` for
// `npm run build`, `.env.development` for `npm run build:dev`). This guarantees
// the shipped bundle is self-contained and cannot be overridden by an
// incomplete or stale runtime `window._env_`. Flip back to `false` to restore
// runtime-env precedence once env-config.js is ready.
const IGNORE_RUNTIME_ENV = true;

export function getEnv(key: string, fallback?: string): string {
  if (!IGNORE_RUNTIME_ENV) {
    const windowValue =
      typeof window !== 'undefined' ? window._env_?.[key] : undefined;

    if (windowValue && windowValue !== '_') {
      return windowValue;
    }
  }

  const reactAppValue = process.env[key];

  if (reactAppValue && reactAppValue !== '_') {
    return reactAppValue;
  }

  return fallback || '';
}
